import React from 'react';
import { Route } from 'react-router-dom';
import SessionExpired from './errors/SessionExpired';
import NotFound from './errors/NotFound';

export const SessionExpiredRoute = (
    <Route key="session-expired" path="/session-expired" element={<SessionExpired />} />
);

export const NotFoundRoute = <Route key="not-found" path="*" element={<NotFound />} />;
